// extracted by mini-css-extract-plugin
module.exports = {"Value":"percentage-change_Value__CoOqv"};